import httpPortal from './http-portal'

class Occurrence {
  nestedOccurrenceById (id) {
    return httpPortal.get(`/private/api/v1/ocurrences/${id}`)
  }
}

export default new Occurrence()



// WEBPACK FOOTER //
// ./src/services/occurrence.js